function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Image } from "../..";
import { getRest } from "../../utils";

/**
 * A Sprite.
 *
 * @class Sprite
 * @extends {Component}
 */
import { jsx as _jsx } from "react/jsx-runtime";
var Sprite = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Sprite, _React$PureComponent);
  /**
         * Creates an instance of Sprite.
         *
         * @param {any} args
         * @memberof Sprite
         */
  function Sprite() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    /**
       * Handle focus.
       *
       * @memberof Sprite
       */
    _this.handleFocus = function () {
      _this.setState({
        hovered: false
      });
    };
    /**
       * Handle mouse over.
       *
       * @memberof Sprite
       */
    _this.handleMouseOver = function () {
      _this.setState({
        hovered: true
      });
    };
    /**
       * Handle mouse leave.
       *
       * @memberof Sprite
       */
    _this.handleMouseLeave = function () {
      _this.setState({
        hovered: false
      });
    };
    _this.state = {
      hovered: false
    };
    return _this;
  }
  var _proto = Sprite.prototype;
  /**
     * Render the component.
     *
     * @returns
     * @memberof Sprite
     */
  _proto.render = function render() {
    var _this$props = this.props,
      active = _this$props.active,
      disabled = _this$props.disabled,
      height = _this$props.height,
      image = _this$props.image,
      width = _this$props.width;
    var hovered = this.state.hovered;
    var rest = getRest(Sprite, this.props);
    var _ref = rest || {},
      style = _ref.style;
    return /*#__PURE__*/_jsx(Image, Object.assign({}, _.omit(rest, style), {
      onFocus: this.handleFocus,
      onMouseOver: this.handleMouseOver,
      onMouseLeave: this.handleMouseLeave,
      style: Object.assign({
        width: width,
        height: height
      }, style),
      children: /*#__PURE__*/_jsx("i", {
        style: {
          width: '100%',
          height: '100%',
          outline: 'none',
          border: 'none',
          background: 'none',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: "-" + (hovered ? width : 0) + "px -" + (active ? height : 0) + "px",
          backgroundImage: "url(" + image + ")",
          opacity: disabled ? '0.15' : '1',
          cursor: disabled ? 'auto' : 'pointer',
          display: 'inline-block'
        }
      })
    }));
  };
  return Sprite;
}(React.PureComponent);
/**
 * Prop types.
 */
Sprite.handledProps = ["active", "disabled", "height", "image", "width"];
Sprite.propTypes = {
  /** Active. */
  active: PropTypes.bool,
  /** Disabled. */
  disabled: PropTypes.bool,
  /** Height. */
  height: PropTypes.number,
  /** Image. */
  image: PropTypes.string,
  /** Width. */
  width: PropTypes.number
};
Sprite.defaultProps = {
  width: 21,
  height: 21
};
export default Sprite;